import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAspectRatio34: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconAspectRatio34"><Path d="M4 2V22H20V2H4Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAspectRatio34;
